import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withMediaQueries } from 'hoc/withMediaQueries';

import { Container } from 'ui/gridSystem';

import { Footer } from 'ui/components';
import MainContainer from 'pages/style';
import { HeaderIcon, Header, HeaderWrapper, Text } from 'pages/Profile/style';
import ProText from 'ui/typography/proText';
import { useParams } from 'react-router';
import routes from 'routes';
import { push } from 'redux-first-history';
import FollowProfile from 'ui/components/FollowProfile';
import { isManager } from 'utils/roles';

const FollowProfileUser = ({ pushUrl, clientEnabled }) => {
  const { userId } = useParams();

  return (
    <>
      <MainContainer>
        <Header>
          <Container>
            <HeaderWrapper>
              <HeaderIcon
                className="icon-arrow-right first"
                onClick={() => pushUrl(routes.userProfile.path)}
              />
              <Text>
                <ProText type="title" configuration={{ color: 'white' }}>
                  Torna al tuo profilo
                </ProText>
              </Text>
            </HeaderWrapper>
          </Container>
        </Header>
        <FollowProfile userId={userId} isSelection={isManager(clientEnabled)} />
      </MainContainer>
      <Footer />
    </>
  );
};

FollowProfileUser.propTypes = {
  //HOC (connect, state)
  clientEnabled: PropTypes.array,

  //HOC (connect, dispatch)
  pushUrl: PropTypes.func

  //HOC withMediaQueries
};

export default connect(
  state => {
    const {
      user: { clientEnabled }
    } = state.authentication;
    return {
      clientEnabled
    };
  },
  dispatch => ({
    pushUrl: url => dispatch(push(url))
  })
)(withMediaQueries(FollowProfileUser));
